import React, { useState, useContext } from 'react'
import {
    TextField,
    InputAdornment,
    Select,
    MenuItem,
    FormHelperText,
    Grid,
} from '@material-ui/core'
import { BrowserView, MobileView, isBrowser } from 'react-device-detect'
import FlexView from 'react-flexview/lib'
import { Controller, useForm, useFormContext } from 'react-hook-form'
import { SessionContextStore } from '../../../context/SessionContext'
import {
    UserProfileContextStore,
    ACTIONS,
} from '../../../context/UserProfileContext'
import { OptionalTag } from '../../Core/OptionalTag'
import { UserApi } from '../../../api/user.api'
import {
    EventEmitterService,
    EventKey,
} from '../../../services/EventEmitterService'
import '../UserProfile.css'
import { Action } from '../../../models/Action'
import { SessionService } from '../../../services/SessionService'
import StorageService from '../../../services/StorageService'
import { STATE_EXPIRY_TTL, COUNTRIES, POBOX_REGEX } from '../../../Constants'
import {
    FirebaseService,
    FirebaseConfigKey,
} from '../../../services/FirebaseService'
import {
    showError,
    awaitWithLoading,
    isTodayBreakdown,
} from '../../../services/utils'
import LocalizationService from '../../../services/LocalizationService'
import { ProposalSessionContextStore } from '../../../context/ProposalSessionContext'
import { useLocation } from 'react-router-dom'
import { usePlacesWidget } from 'react-google-autocomplete'

export const AddressSection = ({ isParentMode = false, ...props }) => {
    const location = useLocation()
    let sessionContext = useContext(SessionContextStore)
    const profileContext = useContext(UserProfileContextStore)
    const [states, setStates] = useState([])
    const { register, watch, trigger, setValue, errors, control, getValues } =
        useFormContext()
    //  { defaultValues: {
    //      address_line_1: sessionContext.user.address1,
    //      address_line_2: sessionContext.user.address2,
    //      city: sessionContext.user.city,
    //      zipcode: sessionContext.user.zipCode,
    //      state: sessionContext.user.state ? sessionContext.user.state : FirebaseService.getValue(FirebaseConfigKey.COUNTRY) == COUNTRIES.UK ? COUNTRIES.UK : 'statedefault',
    //  }, mode: 'onChange' } : { mode: 'onChange'})

    const address1Watch = watch('address_line_1', '')
    const address2Watch = watch('address_line_2', '')
    const cityWatch = watch('city', '')
    const zipcodeWatch = watch('zipcode', '')
    const stateWatch = watch('state')
    const zipcodeRegex = new RegExp(
        FirebaseService.getValue(FirebaseConfigKey.ZIPCODE_REGEX)
    )
    const restrictedCountries: any[] = FirebaseService.getArray(
        FirebaseConfigKey.RESTRICTED_COUNTRIES
    )
    const methods = useForm({ mode: 'onChange' })

    const setStateFromAutocomplete = (autoState) => {
        let selected = states.filter(
            (i) => i.name.toLowerCase() == autoState.toLowerCase()
        )
        if (selected.length > 0) setValue('state', selected[0].code)
    }

    const { ref: materialRef } = usePlacesWidget({
        apiKey: process.env.REACT_APP_GOOGLE_PLACE_API_KEY,
        onPlaceSelected: (place) => {
            let address = place['address_components']
            let address_types = []
            setValue('address_line_1', '')
            for (const [i, address] of place['address_components'].entries()) {
                if (address.hasOwnProperty('types')) {
                    address_types[address['types'][0]] = {
                        short_name: address['short_name'],
                        long_name: address['long_name'],
                    }
                }
            }
            setValue(
                'address_line_1',
                address_types.hasOwnProperty('route')
                    ? address_types.hasOwnProperty('street_number')
                        ? address_types['street_number']['long_name'] +
                          ' ' +
                          address_types['route']['long_name']
                        : address_types['route']['long_name']
                    : ''
            )
            setValue(
                'city',
                address_types.hasOwnProperty('locality')
                    ? address_types['locality']['long_name']
                    : address_types.hasOwnProperty('sublocality_level_1')
                    ? address_types['sublocality_level_1']['long_name']
                    : ''
            )
            setValue(
                'state',
                address_types.hasOwnProperty('administrative_area_level_1')
                    ? address_types['administrative_area_level_1']['short_name']
                    : ''
            )
            setValue(
                'zipcode',
                address_types.hasOwnProperty('postal_code')
                    ? address_types['postal_code']['short_name']
                    : ''
            )
        },
        inputAutocompleteValue: 'street_address',
        options: {
            componentRestrictions: {
                country: [process.env.REACT_APP_AUTO_COMPLETE_ADDRESS_COUNTRY],
            },
            types: ['geocode', 'establishment'],
        },
        selectProps: {
            placeholder: 'here is the placeholder text',
        },
    })

    React.useEffect(() => {
        let country = restrictedCountries.find((c) => c.code == stateWatch)

        if (country) {
            // if(country.code == 'KY')
            //     showError('Kentucky is tricky!', <div>
            //             <div>
            //                 Online purchase is not available in Kentucky, but our Support specialists can provide you with coverage.
            //             </div>
            //             <a target="_blank" rel="noreferrer" href="https://faq.skywatch.ai/hc/en-us/requests/new">Contact us</a> and we'll do our best to find you the right coverage.
            //         </div>)
            // else if(country.code == 'NY')
            //     showError('New York is tricky!', <div>
            //             <div>
            //                 Online purchase is not available in New York, but we still wish to do our best to serve you.
            //             </div>
            //             <a target="_blank" rel="noreferrer" href="https://faq.skywatch.ai/hc/en-us/requests/new">Contact us</a> and we'll do our best to find you the right coverage.
            //         </div>)
            // else
            showError(
                'Skywatch is not available in ' + country.name.slice(0, -1),
                `Drop us a message to support@skywatch.ai and we'll notify 
                    you when SkyWatch is available 
                    in your ${
                        FirebaseService.getValue(FirebaseConfigKey.COUNTRY) ==
                        COUNTRIES.CANADA
                            ? 'province'
                            : 'state'
                    }`
            )
        }
    }, [stateWatch])

    React.useEffect(() => {
        setValue(
            'address_line_1',
            !isParentMode
                ? sessionContext.user.address1
                : sessionContext.user?.parent?.address1
        )
        setValue(
            'city',
            !isParentMode
                ? sessionContext.user.city
                : sessionContext.user?.parent?.city
        )
        setValue(
            'zipcode',
            !isParentMode
                ? sessionContext.user?.zipCode
                : sessionContext.user?.parent?.zip_code
        )
        setValue(
            'state',
            !isParentMode
                ? sessionContext.user?.state
                : sessionContext.user?.parent?.administrative_division
        )
    }, [sessionContext.user])

    React.useEffect(() => {
        const fetchData = async () => {
            let res = await UserApi.getStates()

            if (res.ok) {
                setStates(res.parsedData)
                StorageService.setWithExpiry(
                    'STATE_LIST',
                    res.parsedData,
                    STATE_EXPIRY_TTL
                )
            } else {
                EventEmitterService.dispatch(EventKey.ShowError, res)
            }
        }

        if (StorageService.getWithExpiry('STATE_LIST')) {
            setStates(StorageService.getWithExpiry('STATE_LIST'))
        } else {
            fetchData()
        }

        let id = EventEmitterService.subscribe(
            EventKey.USER_PROFILE_SAVE,
            async () => {
                let valid = await methods.trigger()
                if (valid) {
                    profileContext.dispatch(
                        new Action(ACTIONS.SAVE_ADDRESS, getValues())
                    )
                }
            }
        )

        return function cleanup() {
            EventEmitterService.unsubscribe(EventKey.USER_PROFILE_SAVE, id)
        }
    }, [])

    return (
        <Grid container spacing={3} className="margin-top-small">
            <Grid item xs={12} md={6}>
                {POBOX_REGEX.test(getValues('address_line_1')) &&
                    getValues('state') == 'FL' &&
                    getValues('address_line_1') != '' &&
                    delete errors['address_line_1']}
                <Controller
                    rules={{
                        required: 'Required',
                        validate: (x) => {
                            if (
                                !POBOX_REGEX.test(x) &&
                                getValues('state') == 'FL'
                            ) {
                                return 'Please provide a physical address'
                            }
                        },
                    }}
                    control={control}
                    name="address_line_1"
                    as={
                        <TextField
                            InputLabelProps={{ shrink: !!address1Watch }}
                            fullWidth
                            variant="outlined"
                            label="Address"
                            autoComplete="address"
                            name="address_line_1"
                            inputRef={materialRef}
                            error={!!errors.address_line_1}
                            helperText={errors?.address_line_1?.message}
                        />
                    }
                />
            </Grid>
            {/* <Grid item xs={12} md={2}>
                <TextField 
                    InputProps={{endAdornment: <InputAdornment position="start"> <OptionalTag /> </InputAdornment>}} 
                    InputLabelProps={{ shrink: !!address2Watch }} fullWidth variant="outlined" label="Address line 2" autoComplete='address' name="address_line_2" inputRef={register} error={!!errors.address_line_2} />
            </Grid> */}
            <Grid item xs={12} md={2}>
                {getValues('city') != '' && delete errors['city']}
                <TextField
                    InputLabelProps={{ shrink: !!cityWatch }}
                    fullWidth
                    variant="outlined"
                    label="City"
                    name="city"
                    helperText={!!errors.city && 'Required'}
                    inputRef={register({ required: true })}
                    error={!!errors.city}
                />
            </Grid>
            <Grid item xs={6} md={2}>
                {getValues('state') != '' && delete errors['state']}
                <Controller
                    rules={{
                        required: true,
                        validate: (x) => x && x != 'statedefault',
                    }}
                    name="state"
                    defaultValue={sessionContext.user.state}
                    as={
                        <TextField
                            error={!!errors.state}
                            fullWidth
                            label={LocalizationService.STRINGS.state}
                            select
                            variant="outlined"
                            className=""
                        >
                            <MenuItem disabled value={'statedefault'}>
                                <div className="placeholder-text">
                                    {LocalizationService.STRINGS.state}
                                </div>
                            </MenuItem>
                            {[...states, ...restrictedCountries]
                                .sort((a, b) => a.name.localeCompare(b.name))
                                .map((item) => (
                                    <MenuItem key={item.code} value={item.code}>
                                        {item.name}
                                    </MenuItem>
                                ))}
                        </TextField>
                    }
                    control={control}
                />
                {!!errors.state && (
                    <FormHelperText
                        error={!!errors.state}
                        className="stateValidationMsg"
                    >
                        {errors.state.type == 'validate'
                            ? 'Not available'
                            : 'Required'}
                    </FormHelperText>
                )}
                <TextField
                    name="state"
                    onChange={(e) => {
                        setStateFromAutocomplete(e.target.value)
                    }}
                    style={{ height: 0, width: 0 }}
                />
            </Grid>
            <Grid item xs={6} md={2}>
                {getValues('zipcode') != '' && delete errors['zipcode']}
                <TextField
                    InputLabelProps={{ shrink: !!zipcodeWatch }}
                    fullWidth
                    variant="outlined"
                    label={LocalizationService.STRINGS.zipcode}
                    name="zipcode"
                    inputRef={register({
                        required: true,
                        validate: (x) => zipcodeRegex.test(x),
                    })}
                    helperText={
                        !!errors.zipcode &&
                        `Invalid ${LocalizationService.STRINGS.zipcode}`
                    }
                    error={!!errors.zipcode}
                />
            </Grid>
        </Grid>
    )
}
